import * as THREE from 'three';

export const createPCBs = (
    scene: THREE.Scene,
    materials: any,
    componentsRef: React.MutableRefObject<Array<{
        mesh: THREE.Mesh;
        solidMaterial: THREE.Material;
        wireframeMaterial: THREE.Material;
    }>>
) => {
    const pcbCount = 5;

    for (let i = 0; i < pcbCount; i++) {
        const pcbGroup = new THREE.Group();
        pcbGroup.position.set(
            (i - (pcbCount - 1) / 2) * 3,
            0.75,
            0
        );

        // PCB 基板
        const pcbBaseGeometry = new THREE.BoxGeometry(2, 0.1, 1.5);
        const pcbBaseMesh = new THREE.Mesh(pcbBaseGeometry, materials.solidGreenPCB.clone());
        pcbBaseMesh.position.set(0, 0, 0);
        pcbGroup.add(pcbBaseMesh);
        componentsRef.current.push({
            mesh: pcbBaseMesh,
            solidMaterial: materials.solidGreenPCB.clone(),
            wireframeMaterial: materials.wireframeCyan.clone()
        });

        // 模拟芯片 (方形)
        const chipGeometry = new THREE.BoxGeometry(0.4, 0.15, 0.4);
        const chip1 = new THREE.Mesh(chipGeometry, materials.solidBlack.clone());
        chip1.position.set(-0.5, 0.1, 0.2);
        pcbGroup.add(chip1);
        componentsRef.current.push({
            mesh: chip1,
            solidMaterial: materials.solidBlack.clone(),
            wireframeMaterial: materials.wireframeCyan.clone()
        });

        const chip2 = new THREE.Mesh(chipGeometry, materials.solidBlack.clone());
        chip2.position.set(0.5, 0.1, -0.2);
        pcbGroup.add(chip2);
        componentsRef.current.push({
            mesh: chip2,
            solidMaterial: materials.solidBlack.clone(),
            wireframeMaterial: materials.wireframeCyan.clone()
        });

        scene.add(pcbGroup);
    }
}; 